import TeamsMembersModal from 'modules/teams/components/MembersModal'
import TeamModal from 'modules/teams/components/TeamModal'

const AddMembersModal = () => <TeamModal modalComponent={TeamsMembersModal} />
export default AddMembersModal
